'use strict';

require("core-js/modules/es6.object.define-property");

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

var EndpointService =
/*#__PURE__*/
function () {
  function EndpointService(httpApi) {
    if (!httpApi) throw new Error('Missing param: httpApi');
    this.httpApi = httpApi;
  }

  var _proto = EndpointService.prototype;

  _proto.run = function run(method, path, params) {
    switch (method) {
      case 'GET':
        return this.httpApi.get(path, params);

      case 'POST':
        return this.httpApi.post(path, params);

      case 'PUT':
        return this.httpApi.put(path, params);

      case 'DELETE':
        return this.httpApi.del(path, params);

      default:
        throw new Error('EndpointService: bad method');
    }
  };

  _createClass(EndpointService, [{
    key: "apiPrefix",
    get: function get() {
      return this.httpApi.apiPrefix;
    }
  }]);

  return EndpointService;
}();

exports.EndpointService = EndpointService;